const monoThemeScript = document.currentScript;
const monoSwiperScriptUrl = monoThemeScript && monoThemeScript.dataset.swiperScript;
const monoSwiperStylesUrl = monoThemeScript && monoThemeScript.dataset.swiperStyles;

window.loadMonoSwiper = function() {
  if (window.Swiper) return Promise.resolve(window.Swiper);
  if (window.monoSwiperPromise) return window.monoSwiperPromise;

  const stylesheetPromise = new Promise((resolve, reject) => {
    let stylesheet = document.querySelector('link[data-mono-swiper-styles]');
    if (stylesheet && stylesheet.sheet) {
      resolve();
      return;
    }
    if (!stylesheet) {
      stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = monoSwiperStylesUrl;
      stylesheet.dataset.monoSwiperStyles = '';
      document.head.appendChild(stylesheet);
    }
    stylesheet.addEventListener('load', resolve, { once: true });
    stylesheet.addEventListener('error', reject, { once: true });
  });

  const scriptPromise = new Promise((resolve, reject) => {
    let script = document.querySelector('script[data-mono-swiper-library]');
    if (!script) {
      script = document.createElement('script');
      script.src = monoSwiperScriptUrl;
      script.dataset.monoSwiperLibrary = '';
      document.head.appendChild(script);
    }
    script.addEventListener('load', () => resolve(window.Swiper), { once: true });
    script.addEventListener('error', reject, { once: true });
  });

  window.monoSwiperPromise = Promise.all([stylesheetPromise, scriptPromise]).then(() => window.Swiper);
  return window.monoSwiperPromise;
};

// modal
let lastModalTrigger = null;

// const modals = document.querySelectorAll('.js-modal');
// modals.forEach((elm)=>{
//   document.body.append(elm);
// });
function openModal(target) {
  const targetModal = document.querySelector(`.${target}`);
  if (targetModal == null) return;

  lastModalTrigger = document.activeElement;
  let scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.body.style.paddingRight = `${scrollbarWidth}px`;
  const modaBG = document.createElement('div');
  modaBG.classList.add('modal-bg');
  // document.body.append(modaBG);
  targetModal.parentNode.append(modaBG);
  const closeBtn = targetModal.querySelector(`.js-modal-close`);
  targetModal.classList.add('modal-open');
  targetModal.setAttribute('aria-hidden', 'false');
  if (lastModalTrigger != null) lastModalTrigger.setAttribute('aria-expanded', 'true');
  modaBG.addEventListener('click', closeModal);
  if(closeBtn != null) {
    closeBtn.onclick = closeModal;
  }
  targetModal.focus();
}

function closeModal() {
  const activeModal = document.querySelector('.modal-open');
  const activeBG = document.querySelector('.modal-bg');
  if(activeModal != null) {
    activeModal.classList.remove('modal-open');
    activeModal.setAttribute('aria-hidden', 'true');
  }
  if(activeBG != null) {
    activeBG.parentNode.removeChild(activeBG);
  }
  document.body.style.paddingRight = `0px`;
  if(lastModalTrigger != null) {
    lastModalTrigger.setAttribute('aria-expanded', 'false');
    lastModalTrigger.focus();
    lastModalTrigger = null;
  }
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && document.querySelector('.modal-open') != null) closeModal();
});

const quickAddSubmit = document.querySelectorAll('.quick-add__submit');
let offsetY = 50;
quickAddSubmit.forEach((elm)=>{
  elm.addEventListener('click', ()=>{
    const modalId = elm.parentNode.getAttribute('data-modal');
    if(modalId != null) {
      const quickAddModal = document.querySelector(modalId).querySelector('.quick-add-modal__content');
      quickAddModal.addEventListener('scroll', ()=>{
        offsetY = 50 + (quickAddModal.scrollTop / quickAddModal.offsetHeight) * 100;
      });
      setTimeout(()=>{
        if(quickAddModal != null) {
          const offsetTarget = quickAddModal.querySelector('.modal-anchor');
          offsetTarget.addEventListener('click', ()=>{
            quickAddModal.querySelector('.js-modal').style.top = `${offsetY}%`;
          });
        }
      }, 1000);
    }
  });
});
// modal 
